import {
  Box,
  Button,
  Fab,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

import Grid from "@mui/material/Grid";

import React, { useEffect, useState } from "react";
import { getAllOffer, getMessageCount } from "./apiFunction";
import Card from "./card";
import CardEle from "./card";
import PopUp from "./PopUp";
import AddIcon from "@mui/icons-material/Add";
import PopUpWp from "./PopUpWp";
import { PaginationCm } from "../../common/pagination";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { swalAlertPopProps } from "../../utils/commonUtils";
import Swal from "sweetalert2";
import { Filter } from "../../common/fiterComp";

export default function BulkMessage({}) {
  const [numberOfPage, setnumberOfpages] = useState(1);
  const [collection, setColletion] = useState([]);

  const [collectionCredit, setCollectionCredit] = useState([]);

  const get = () => {
    getMessageCount((data) => {
      console.log("what app count", data?.data?.data);

      if (data?.data?.data?.totalCount <= 10) {
        Swal.fire({
          title: "Credits are about to end",

          text: "Recharge soon to continue service",
          icon: "warning",

          // ...swalAlertPopProps,
          // timer: 2000,
          // Adj
        });
      }

      setCollectionCredit(data?.data?.data);
    });
  };

  useEffect(() => {
    getAllOffer((data) => {
      console.log("Salon/GetAllOffers ", data?.data);
      setColletion(data?.data?.list);
    });
    get();
  }, []);
  const [open, setOpen] = useState(false);
  const [opent, setOpent] = useState(false);

  const [getDataPayload,setGetDataPykoad]=useState({
    page: 1,
    pageSize: 1000,
    filter: "",
    search: "",
    filter2: "",
    search2: ""
  })
  const [data, setData] = useState(null);
  return (
    <>
      <DynamicBreadcrumbs />
      <Box
        sx={{
          margin: {
            xs: "10px",
            sm: "50px 10px 10px 10px ",
            md: "50px",
          },
        }}
      >
      {/* <Filter setGetDataPykoad={setGetDataPykoad} getDataPayload={getDataPayload} /> */}

        <Grid container spacing={2} alignItems="center" padding={2}>
          <Grid item md={12} xs={12}>
            <Grid xs={12}>
              <Typography variant="standard" component={"h4"} color="red">
                Your Credit Messages :- {collectionCredit?.totalCount}
              </Typography>
            </Grid>

            <Box sx={{ width: "100%", textAlign: "right" }}>
              <Fab
                onClick={() => {
                  // setOpen(true);
                  setData(null);
                  setOpen(true);
                }}
                sx={{
                  textTransform: "capitalize",
                  width: {
                    xs: "100%",
                    sm: "auto",
                  },
                  // p: "10px",
                  whiteSpace: "nowrap",
                  zIndex: "0",
                }}
                size="small"
                color="primary"
                variant="extended"
                aria-label="add"
              >
                <AddIcon />
                Add New Message
              </Fab>
            </Box>
          </Grid>
          {/* <Grid item xs={6}>
            {collection.map((ele, index) => {
              return (
                <CardEle
                  item={ele}
                  callback={(data) => {
                    setOpen(true);
                    setData(ele);
                  }}
                  cbt={(data) => {
                    setOpent(true);
                    // setData()
                    setData(ele);
                  }}
                />
              );
            })}
          </Grid> */}

          <Grid container spacing={2}>
            {collection.map((ele, index) => (
              <Grid item xs={6} key={index}>
                <CardEle
                  item={ele}
                  callback={() => {
                    setOpen(true);
                    setData(ele);
                  }}
                  cbt={() => {
                    setOpent(true);
                    setData(ele);
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
        <PopUp open={open} setOpen={setOpen} data={data} />

        <PopUpWp
          open={opent}
          callbackGetMsg={() => {
            get();
          }}
          countCredit={collectionCredit?.totalCount}
          setOpen={setOpent}
          data={data}
          feature={"bulkupload"}
        />
      </Box>
    </>
  );
}
